module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'scanBarcode') ? _c('scanBarcode', {
    on: {
      "setBarcode": _vm.getBarcode
    }
  }) : _vm._e(), (_vm.stage === 'ScheduleList') ? _c('ScheduleList', {
    attrs: {
      "fireRefetch": _vm.fireRefetch,
      "viewMode": 'scheduleList',
      "filterOutZeroAmountMed": true
    },
    on: {
      "setSchedule": _vm.getSchedule
    }
  }) : _vm._e(), (_vm.stage === 'selectDrug') ? _c('EventTable', {
    attrs: {
      "eventType": _vm.eventType,
      "singleSelection": false,
      "number2": _vm.$store.state.schedule.currentSchedule.id
    }
  }) : _vm._e(), (_vm.stage === 'startFlow') ? _c('MultiFlow', {
    attrs: {
      "startType": 'event',
      "barcodeData": _vm.barcodeData,
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), ((_vm.stage === 'ScheduleList' || _vm.stage === 'scanBarcode') && _vm.$store.state.generalSetting.mode === 'nursing') ? _c('action-button', {
    attrs: {
      "slot": "button-3",
      "title": "病人列表"
    },
    nativeOn: {
      "click": function($event) {
        _vm.stage = 'ScheduleList'
      }
    },
    slot: "button-3"
  }) : _vm._e(), (_vm.stage === 'ScheduleList' || _vm.stage === 'scanBarcode') ? _c('action-button', {
    attrs: {
      "slot": "button-3",
      "title": "掃描條碼"
    },
    nativeOn: {
      "click": function($event) {
        _vm.stage = 'scanBarcode'
      }
    },
    slot: "button-3"
  }) : _vm._e(), (_vm.stage === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始退藥",
      "clickable": _vm.$store.state.drugInDevice.selectedDrugInDeviceID.length > 0 || _vm.$store.state.event.selectedEventId.length > 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d166625","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScheduleReturn.vue
// module id = 1503
// module chunks = 1